import React from 'react';
import { node, string } from 'prop-types';
import classNames from 'classnames';
import Item from './Item';

const Grid = ({ className, children }) => (
    <section className={classNames('grid', 'grid-12', className)}>{children}</section>
);

Grid.propTypes = {
    className: string,
    children: node,
};

Object.assign(Grid, {
    Item,
});

export default Grid;
